import React, { useCallback } from 'react';
import {
  AppInsightsErrorBoundary,
  useAppInsightsContext,
} from '@microsoft/applicationinsights-react-js';
import { FunctionComponent } from 'react';
import { FallbackErrorBoundry } from './FallbackErrorBoundry';
import './CustomErrorBoundary.less';
import POSButton from '../POSButton';
import ErrorMessageWithActions from '../ErrorMessgeWithActions';

export type CustomErrorBoundaryProps = {
  errorText?: string;
  children: React.ReactElement;
};

const ErrorMessage = ({ errorText }: { errorText: string | undefined }) => {
  const handleRefreshClick = useCallback(() => window.location.reload(), []);

  return (
    <ErrorMessageWithActions
      errorText={errorText}
      actions={
        <POSButton className="error-button" onClick={handleRefreshClick}>
          REFRESH
        </POSButton>
      }
    />
  );
};

export const CustomErrorBoundary: FunctionComponent<
  CustomErrorBoundaryProps
> = ({ errorText, children }) => {
  const appInsights = useAppInsightsContext();

  if (!appInsights) {
    return (
      <FallbackErrorBoundry message={<ErrorMessage errorText={errorText} />}>
        {children}
      </FallbackErrorBoundry>
    );
  }

  return (
    <AppInsightsErrorBoundary
      onError={() => <ErrorMessage errorText={errorText} />}
      appInsights={appInsights}
    >
      {children}
    </AppInsightsErrorBoundary>
  );
};
